import { render } from "./JointFiles.vue?vue&type=template&id=9b0da878"
import script from "./JointFiles.vue?vue&type=script&lang=js"
export * from "./JointFiles.vue?vue&type=script&lang=js"

import "./JointFiles.vue?vue&type=style&index=0&id=9b0da878&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__